<div class="mx-auto gap-top text-center text-color">
  @if (errorNumber === "401") {
    <h1>{{ "error.authenticationRequired" | translate }}</h1>
  }
  @if (errorNumber === "403") {
    <h1>{{ "error.authorizationRequired" | translate }}</h1>
  }
  @if (errorNumber === "404") {
    <h1>{{ "error.pageNotFound" | translate }}</h1>
  }
  <img class="mt-2" src="assets/img_error.svg" alt="image d'erreur" />
</div>
